<script setup>
defineProps({
  validationErrorList: {
    type: Array,
    default: () => []
  }
});

const displayValidate = value => {
  return value.join("\n");
};
</script>

<template>
  <div class="block">{{ displayValidate(validationErrorList) }}</div>
</template>

<style scoped lang="stylus">
.block
  white-space pre
  text-align left
  color darkred
</style>
